import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import authorizer from './modules/authorizer'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    authorizer
  }
})
